import { makeIcon } from "components/ui/Icon";

export const LessThanOrEqualOperatorIcon = makeIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <rect fill="var(--foreground)" height="24" rx="4" width="24" />
    <path d="M14.4926 17L6 10L14.4926 3L16 4.2L9.01486 10L16 15.8L14.4926 17Z" fill="var(--background)" />
    <path d="M7 20V18H17V20H7Z" fill="var(--background)" />
  </svg>,
);
